define [], () ->
  ($scope, $uibModalInstance, $rootScope) ->
    $scope.close = () ->
      $uibModalInstance.close(true)

    $scope.clear_signature = () ->
      $scope.field.value = null

      $rootScope.$broadcast('signature-clear', { 
          name: $scope.field.name
      })



// WEBPACK FOOTER //
// ./directives/freeforms/newSignatureModal/signatureModal.coffee